var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4499 13.6406V14.6406C21.4499 14.9106 21.2399 15.1306 20.9599 15.1406H19.4999C18.9699 15.1406 18.4899 14.7506 18.4499 14.2306C18.4199 13.9206 18.5399 13.6306 18.7399 13.4306C18.9199 13.2406 19.1699 13.1406 19.4399 13.1406H20.9499C21.2399 13.1506 21.4499 13.3706 21.4499 13.6406Z",
    fill: "#095228"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9902 12.6906C17.4902 13.1806 17.2502 13.9106 17.4502 14.6706C17.7102 15.6006 18.6202 16.1906 19.5802 16.1906H20.4502C21.0002 16.1906 21.4502 16.6406 21.4502 17.1906V17.3806C21.4502 19.4506 19.7602 21.1406 17.6902 21.1406H6.2102C4.1402 21.1406 2.4502 19.4506 2.4502 17.3806V10.6506C2.4502 9.42062 3.0402 8.33063 3.9502 7.65063C4.5802 7.17063 5.3602 6.89062 6.2102 6.89062H17.6902C19.7602 6.89062 21.4502 8.58062 21.4502 10.6506V11.0906C21.4502 11.6406 21.0002 12.0906 20.4502 12.0906H19.4302C18.8702 12.0906 18.3602 12.3106 17.9902 12.6906Z",
    fill: "#095228"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2001 4.82C16.4701 5.09 16.2401 5.51 15.8601 5.51L8.18006 5.5C7.74006 5.5 7.51006 4.96 7.83006 4.65L9.45006 3.02C10.8201 1.66 13.0401 1.66 14.4101 3.02L16.1601 4.79C16.1701 4.8 16.1901 4.81 16.2001 4.82Z",
    fill: "#095228"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentStatus);
export default __webpack_public_path__ + "static/media/payment-status.a12a3c8f09bd1f618a86880acf3edf86.svg";
export { ForwardRef as ReactComponent };